<template>
  <div class="map-container" v-if="showPicker" style="font-size:0;">
    <iframe id="mapPage" width="100%" height="101%" frameborder=0
      src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=EFIBZ-V66WR-UECWI-WVAKH-ENUUE-KBB7W&referer=myapp">
    </iframe>
    <div class="header">
      <div @click="back">取消</div>
      <div class="btn-confirm" v-if="selectedPoi" @click="handleConfirm">完成</div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'location-picker',
  data:() => ({
    selectedPoi: null,
    showPicker: false,
  }),

  created() {
    window.addEventListener('message',event => {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data
        if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          this.selectedPoi = loc
        }
    }, false)
  },

  mounted() {
    this.$bus.$on('showLocationPicker', () => {
      this.showPicker = true
    })
  },

  methods: {
    back() {
      // this.$router.back()
      this.showPicker = false
    },

    handleConfirm() {
      this.$bus.$emit('selectLocation',this.selectedPoi)
      this.back()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .map-container {
    /* width: 100vw; */
      position: fixed;
      top: 0;
      left: 0;
      z-index: 20;
      background #fff
    @media screen and (max-width: 924px) {
      height: calc(100vh - 40px);
      width: 100vw;
    }
    @media screen and (min-width: 925px) {
      height: 79vh;
      width: 44vw;
      margin: auto;
      left: 28%;
      top: 7%;
      box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.1)
    }
  }
  
  .header {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 0 10px;
    color: #fff;
    font-size: 14px;
    :first-child {
      color: #000
    }
  }

  .btn-confirm {
    background: #00ACEB;
    border-radius: 5px;
    padding: 4px 8px;
  }
</style>
